import { hasOwnProperty } from '@spazious/dollhouse-utils';

import { MigrationStateV3_0_0 } from './migration-v3.0.0.js';
import { Migration, MigrationVersionEnum } from './types.js';

export type MigrationStateV4_0_0 = {
  space: number;
  name: string | null;
  version: string;
  cursor: string | null;
  nodes: {
    [selector: string]: {
      type: number;
      id: number;
      attrs?: Record<string, any>;
      meta?: Record<string, any>;
    };
  };
};

export const migration_4_0_0: Migration<
  MigrationVersionEnum.v4_0_0,
  MigrationStateV3_0_0,
  MigrationStateV4_0_0
> = {
  version: MigrationVersionEnum.v4_0_0,
  check: (state) => state && (!hasOwnProperty(state, 'name') || !hasOwnProperty(state, 'space')),
  migrate: (state) => {
    const { name, space } = state as any;
    return {
      space: typeof space === 'number' && space ? space : 0,
      name: typeof name === 'string' && name ? name : null,
      version: MigrationVersionEnum.v4_0_0,
      cursor: state.cursor ?? null,
      nodes: state.nodes,
    };
  },
};
